// @flow
import React, { Component } from 'react'
import postJson from '../../services/postJson'
import CreateForm from './CreateForm'
import type { OptionType } from '../types'

type Props = {|
  agencyBillingModelOptions: Array<OptionType>
|}

type State = {|
  isOpen: boolean,
  isLoading: boolean,
  name: string,
  agencyBillingModel: number,
  nameErrors: Array<string>,
  agencyBillingModelErrors: Array<string>,
  commonErrors: Array<string>
|}

const t = {
  server_error: 'Ошибка сервера'
}

const createAdAccountPath = '/api/v1/agencies/ad_accounts'

export default class CreateFormContainer extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isOpen: false,
      isLoading: false,
      name: '',
      agencyBillingModel: props.agencyBillingModelOptions[0].id,
      nameErrors: [],
      agencyBillingModelErrors: [],
      commonErrors: []
    }
  }

  render() {
    return (
      <CreateForm
        isOpen={this.state.isOpen}
        onOpen={() => this.setState({ isOpen: true })}
        onClose={() => this.setState({ isOpen: false })}
        isLoading={this.state.isLoading}
        name={this.state.name}
        agencyBillingModel={this.state.agencyBillingModel}
        agencyBillingModelOptions={this.props.agencyBillingModelOptions}
        onNameChange={(name) => this.setState({ name, nameErrors: [], commonErrors: [] })}
        onAgencyBillingModelChange={(agencyBillingModel) =>
          this.setState({ agencyBillingModel, agencyBillingModelErrors: [], commonErrors: [] })
        }
        onPersist={() => this.makeRequest()}
        nameErrors={this.state.nameErrors}
        agencyBillingModelErrors={this.state.agencyBillingModelErrors}
        commonErrors={this.state.commonErrors}
      />
    )
  }

  makeRequest() {
    this.setState({ isLoading: true })
    postJson(createAdAccountPath, {
      data: {
        name: this.state.name,
        agency_billing_model: this.state.agencyBillingModel
      }
    })
      .done(() => {
        this.setState({ isOpen: false })
        window.location.reload()
      })
      .fail((e: any) => {
        if (e.status === 422) {
          this.setState({
            nameErrors: e.responseJSON.message.name || [],
            agencyBillingModelErrors: e.responseJSON.message.agency_billing_model || [],
            commonErrors: []
          })
        } else {
          this.setState({
            nameErrors: [],
            agencyBillingModelErrors: [],
            commonErrors: [`${e.status} ${t.server_error}`]
          })
        }
      })
      .always(() => this.setState({ isLoading: false }))
  }
}
